import { useApplicationSettings } from "@/application/providers/application-settings/application-settings";

export function useLogo() {
  const settings = useApplicationSettings();

  return {
    src: settings.logo?.link,
    companyName: settings.companyName,
  };
}
